<template>
    <v-card>
        <v-card-title>
            Mobile App Profile Details Control
        </v-card-title>
        <v-card-subtitle>
            These controls can be used to hide/show guest details on the mobile app according to the event.
        </v-card-subtitle>

        <v-data-table :headers="headers"
                      :items="items"
                      :loading="isPending"
                      :items-per-page="itemsLength"
                      hide-default-footer
                      disable-sort>
            

            <template v-slot:item.title="{value}">
                {{value}}
            </template>
            <template v-slot:item.status="{value}">
                {{value}}
                <!-- <v-textarea v-model="">
                    {{switchLabel(value)}}
                </v-textarea> -->
            </template>
            <template v-slot:item.actions="{value}">
                 <v-switch v-model="eventProfile[value]"
                    @change="onChange($event,value)"
                    >
                </v-switch>
            </template>
            
        </v-data-table>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary"
                   @click="saveEventProfile" :disabled="false">
                {{$t('save')}}
            </v-btn>
        </v-card-actions>
    </v-card>
</template>
<style >

.v-input--expand >>> .v-input__slot >>> .v-label {
    display: block;
    flex: 1;
}
</style>
<script>
    import {computed, ref,watch} from '@vue/composition-api';
    import {useGet} from "feathers-vuex";

    export default {
        name: 'EventProfile',
        setup(props, {root}){
            const {Event} = root.$FeathersVuex.api;

            const eventId = computed(()=> root.$route.params.eventId);
            const {item: event, isPending} = useGet({model: Event, id: eventId});

            const eventProfile = computed(() =>{
                return event.value? event.value.events_profile:null;
            });

            const fieldsTitle = {
                "name": "First Name",
                "ev_lastname":"Last Name",
                "ev_empolyeeid": "Employee Id",
                "ev_agencyid": "Agency Id",
                "ev_title": "Salutation",
                "ev_email": "Email",
                "ev_company": "Company",
                "ev_department": "Department",
                "ev_job_title": "Position",
                "ev_office_phone" : "Office Number",
                "ev_country_code": "Country Code",
                "ev_mobile":"Mobile Number",
                "ev_token" : "QR Code",
                "ev_remarks": "Remarks",
                "ev_sms": "SMS",
                "ev_vip_flag": "VIP",
                "ev_exclude_email_reminder": "No Reminder",
            }
            const fields = [
                "name",
                "ev_lastname",
                "ev_empolyeeid",
                "ev_agencyid",
                "ev_title",
                "ev_email",
                "ev_company",
                "ev_department",
                "ev_job_title",
                "ev_office_phone",
                "ev_country_code",
                "ev_mobile",
                "ev_token",
                "ev_remarks",
                "ev_sms",
                "ev_vip_flag",
                "ev_exclude_email_reminder",    
            ]

            const switchLabel = function(value){
                return value?"\tEnabled":"\tDisabled"
            }


            const headers = ref([
                {text: root.$t('event_profile.title'),value:'title'},
                {text: root.$t('event_profile.status'),value:'status'},
                {text: '',value:'actions'},
            ])
            // const items = ref([])
            const saveEventProfile = function() {                
                eventProfile.value.save().then(()=>{
                    root.$store.dispatch('showSnackBar',root.$t('event_profile.save_successful'));
                }, root.$handleFeatherError.bind(root));
            }

            const items = ref([])
            watch(eventProfile,(eventProfile,old)=>{
                if(eventProfile!=null){
                    const itemList = []
                    for(let i=0;i< fields.length;i++){
                        itemList.push({
                            'title': fieldsTitle[fields[i]],
                            'status': switchLabel(eventProfile[fields[i]]),
                            'actions': fields[i],
                        })
                    }
                    items.value = itemList
                }else{
                    items.value = []
                }
            })
            const indexOf = function(fieldTitle){
                for(let i=0;i<items.value.length;i++){
                    if(items.value[i].actions==fieldTitle){
                        return i;
                    }
                }
                return -1;
            }

            const onChange = function(e,fieldTitle){
                items.value[indexOf(fieldTitle)].status = switchLabel(e)
            }
            
            const itemsLength = fields.length

            return {
                fields,
                fieldsTitle,
                switchLabel,

                eventProfile,
                saveEventProfile,

                headers,
                items,
                itemsLength,
                isPending,
                onChange
            }
        }
    }
</script>